import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle() {
  const { isDark, setMode } = useTheme();

  return (
    <div
      role="group"
      aria-label="Theme mode switcher"
      className="flex items-center rounded-full p-0.5 transition-colors border h-7 shrink-0"
      style={{
        background: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)",
        borderColor: "var(--border)",
      }}
    >
      <button
        type="button"
        data-testid="theme-toggle-light"
        onClick={() => setMode("light")}
        aria-label="Switch to Light Theme"
        aria-pressed={!isDark}
        title="Light theme"
        className={`w-6 h-6 rounded-full flex items-center justify-center transition-all ${
          !isDark
            ? "bg-white text-amber-500 shadow-xs font-semibold"
            : "text-slate-400 hover:text-slate-200"
        }`}
      >
        <Sun className="w-3.5 h-3.5" />
      </button>

      <button
        type="button"
        data-testid="theme-toggle-dark"
        onClick={() => setMode("dark")}
        aria-label="Switch to Dark Theme"
        aria-pressed={isDark}
        title="Dark theme"
        className={`w-6 h-6 rounded-full flex items-center justify-center transition-all ${
          isDark
            ? "bg-slate-800 text-blue-400 shadow-xs font-semibold"
            : "text-slate-500 hover:text-slate-800"
        }`}
      >
        <Moon className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
